import { createContext } from 'react';

// The open pedigree, for Suggested Clinical Terms (TGCLOUD-1845).
//
// A document's findings belong to the patient OR to a named relative; to
// attach a relative's finding to that relative, the suggestions panel needs
// the family and the person being edited. ClinicalNotes provides both, so the
// six clinical-record forms need no new props.
//
//   members        memberRecords: every person in the chart, with parent links
//   selected       the member whose record is open
//   refreshFamily  re-reads the family after an accept that wrote to relatives
export const SuggestionFamilyContext = createContext({
  members: [],
  selected: null,
  refreshFamily: null
});
